import FlyersService from './Flyers.service';

export default FlyersService;
